
import styled from "styled-components";
import NavBar from "../../components/NavBar";
export default function Help() {

  return (
    <Wrapper>
      <NavBar title={"帮助"} />
      <Container>
        <div className="text-center">
          <img style={{ width: "60%" }} src="/image/help1.png" alt="" />
        </div>
        {/* <T>Runbit DAO經濟模型</T> */}
        {/* <ST>区块链资深研发团队组建并首推的重大项目</ST>
        <P>
          Runbit DAO，即Run Bit
          DAO，简称RTD，由区块链资深研发团队发起并组建的自治联盟社区，成员包括前Ethereum核心开发者、前Uniswap核心开发者、安全工程师、知名投行交易员、The
          DAO核心成员、欧美及亚太区营销组织等，以公开、自由、民主的DAO为组织形式，打造DEFI、GameFi、元宇宙、实体经济一体化的超级Web3.0聚合生态平台。RunForRT项目是RTD构建的Web3.0生态中的首个虚拟与现实结合的GameFi项目。
        </P> */}

        {/* <T>Runbit DAO项目简介</T>
        <ST>
          共创共富共赢Web3.0的
          <br />
          DAO社区自治体育竞技生态
        </ST>
        <P>
          RunBit
          DAO将通过DAO社区自治的方式搭建基于Web3.0的第三代互联网的体育运动竞技健身平台。平台将首发上线RunForRT项目，旨在建立一个真正的Web3.0元宇宙生态系统，让用户可以在进行体育运动的同时获得收益，从而推动更多的人加入到运动健身的行列中来，促进低碳出行，让健康的观念深入每个人的心中，做到健康就是收益。
        </P> */}

        {/* <T>Runbit DAO项目架构</T>
        <ST>技术架构</ST>
        <P>
          <ul>
            <li>
              DEFI、GameFi、DAO、NFT、Web3.0、去中心化 存储、跨链桥生态架构
            </li>
            <li>
              <span>DEFI生态面</span>--包括去中心化交易平台（DEX）、预
              言机、借贷、机枪池等
            </li>
            <li>
              <span>体育竞技生态面</span>--包括跑步运动、骑行运动、游泳运
              动、电子竞技等体育运动和竞技，也包括虚拟体育装
              备、体育商店、体育公园、电子竞技设备等周边生态
            </li>
            <li>
              <span>NFT生态面</span>--包括运动装备、人物形象、艺术藏品、
              古董字画、纪念邮票等
            </li>
            <li>
              <span>游戏生态面</span>--竞技游戏、战争游戏、战略游戏等游戏 生态
            </li>
            <li>
              <span>实体生态面</span>--电商、竞赛等实体行业
            </li>
          </ul>
        </P> */}

        <T>Runbit DAO 經濟模型</T>
        <ST>RunBit DAO的Token代碼：RT</ST>
        <P>
          <ul>
            <li>經濟模型簡單概括就是銷毀-鑄幣-增長，即DPCG模式，（去中心化鑄幣）這一模型為RT獨創的先進模型。</li>
            <li><span>銷毀：</span>將項目方發幣的權利（鑄幣權）轉移給個人，用戶用於購買裝備和内容卡的代幣將被100%銷毀；</li>
            <li><span>鑄幣：</span>項目中所有代幣都由個人鑄造，鑄幣的權利充分釋放到個人，所有的代幣均是由玩家通過運動、添加流動性、社區建設等途徑進行鑄造，如果個人不產生數據則將不會有新幣產生；</li>
            <li><span>增長：</span>即價值的增長，由於個人鑄幣的管道不會產生濫發濫鑄的情况，完全根據合約規則鑄造，不會產生通脹，且裝備購買的越多銷毀的越多，將形成不斷的通縮，這將不斷推昇RT的價值，從而持續增長持幣者的財富。</li>
            <li><span>發行價：</span>RT發行價為1USD；</li>
            <li>創始團隊獲得產幣量的8%作為獎勵，5%進入社區基金用於社區運營；</li>
            <li><span>通縮機制：</span>遊戲中消耗及購買裝備的RT將100%進行銷毀，無限銷毀，極致通縮。 由於它的通縮性質，代幣的價值會越來越高，從而持續增長持幣者的財富；</li>
            <li><span>流動性池：</span>通過流動性挖礦可鑄造RT，每天最高產量隨著token的發行量動態調整，每天產量約為流動性池中token數量的1/180。</li>
            <li><span>資金池：</span>初始資金池建設由社區前期認購15萬RT加上市值基金預置2000萬RT用以提供早期流動性，並採用分段流動性科技機製，極大提高了資金利用率，可以促進幣價穩定上升，避免因投機導致的幣價震盪。 市值基金預置的2000萬RT將100%被鎖定在智慧合約中，且將被永久鎖死。</li>
          </ul>
        </P>

        <T>Runbit DAO 遊戲規則</T>
        <ST>
        用戶通過購買運動裝備來解鎖卡槽，通過購買屬性卡來獲得内容，有了屬性就可以通過走路跑步等來計步以鑄造RT
        </ST>
        <div style={{ marginBottom: "3.0rem" }}>
          <img src="/image/help2.png" alt="" style={{ width: "100%" }} />
        </div>
        <P>
          <ul>
            <li>
            裝備需插入屬性卡才能賺取跑步收益，每個裝備有3個屬性卡槽，最多可以添加三張屬性卡；
            </li>
            <li>每種裝備共有3個級別，低級別裝備不能安裝高級別的屬性卡；</li>
            <li>
            用戶可以購買1-3級的裝備，1級的裝備的價格按照其稀有度的不同在1 RT-5 RT之間；
            </li>
            <li>相同級別的裝備可以合成為更高級別的裝備，合成需要花費2RT。</li>
            <li>
            用戶需完成5000步才會有完整收益，每少500步，收益减少10%，最少有40%的收益。
            </li>
            <li>
            用戶可以擁有多套相同的裝備，對於每套裝備會對其步數進行單獨計步。
            </li>
          </ul>
        </P>
        <div style={{ marginBottom: "2.1rem", marginTop: "3.0rem" }}>
          <img src="/image/help3.png" alt="" style={{ width: "100%" }} />
        </div>

        <Table>
          <tbody>
            <tr>
              <td></td>
              <td>APY</td>
              <td>耐久</td>
              <td>價格</td>
            </tr>
            <tr>
              <td>1级</td>
              <td>110%</td>
              <td>70天</td>
              <td>200 RT</td>
            </tr>
            <tr>
              <td>2级</td>
              <td>140%</td>
              <td>90天</td>
              <td>500 RT</td>
            </tr>
            <tr>
              <td>3级</td>
              <td>168%</td>
              <td>110天</td>
              <td>1500 RT</td>
            </tr>
            {/* <tr>
              <td>4级</td>
              <td>134%</td>
              <td>90天</td>
              <td>500 RT</td>
            </tr>
            <tr>
              <td>6级</td>
              <td>160%</td>
              <td>110天</td>
              <td>1500 RT</td>
            </tr> */}
          </tbody>
        </Table>
        <Table style={{ marginTop: "1.4rem" }}>
          <tbody>
            <tr>
              <td></td>
              <td>功能性</td>
              <td>美觀性</td>
              <td>舒適性</td>
            </tr>
            <tr>
              <td>是否掉落獎勵</td>
              <td>
                <img
                  style={{ width: "1.4rem" }}
                  src="/image/help_error.png"
                  alt=""
                />
              </td>
              <td>
                <img
                  style={{ width: "1.6rem" }}
                  src="/image/help_check.png"
                  alt=""
                />
              </td>
              <td>
                <img
                  style={{ width: "1.4rem" }}
                  src="/image/help_error.png"
                  alt=""
                />
              </td>
            </tr>
            <tr>
              <td>賽道擁擠損失豁免</td>
              <td>
                <img
                  style={{ width: "1.4rem" }}
                  src="/image/help_error.png"
                  alt=""
                />
              </td>
              <td>
                <img
                  style={{ width: "1.4rem" }}
                  src="/image/help_error.png"
                  alt=""
                />
              </td>
              <td>
                <img
                  style={{ width: "1.6rem" }}
                  src="/image/help_check.png"
                  alt=""
                />
              </td>
            </tr>
            <tr>
              <td>基礎鑄造/天</td>
              <td>0.0001 RT</td>
              <td>0.00008 RT</td>
              <td>0.00008 RT</td>
            </tr>
          </tbody>
        </Table>
        <P>
          <ul>
            <li>屬性卡共有3個級別，不同級別鑄造效率不同；</li>
            <li>屬性卡共有4種内容：耐久性、功能性、美觀性、舒適性；</li>
            <li>屬性卡會按照系列推出，不同系列的屬性卡價格和屬性值不固定；</li>
            <li>100個耐久性值可以挖礦1天；</li>
            <li>美觀性有一定概率獲得裝備掉落；</li>
            <li>舒適性可降低因賽道擁擠而產生的損失；</li>
          </ul>
        </P>
        <div style={{ marginBottom: "2.1rem", marginTop: "3.0rem" }}>
          <img src="/image/help4.png" alt="" style={{ width: "100%" }} />
        </div>
        <Table>
          <tbody>
            <tr>
              <td>裝備</td>
              <td>石子路</td>
              <td>芳草地</td>
              <td>烈日沙灘</td>
            </tr>
            <tr>
              <td>鞋子</td>
              <td>100%</td>
              <td>90%</td>
              <td>90%</td>
            </tr>
            <tr>
              <td>褲子</td>
              <td>90%</td>
              <td>100%</td>
              <td>90%</td>
            </tr>
            <tr>
              <td>上衣</td>
              <td>90%</td>
              <td>90%</td>
              <td>100%</td>
            </tr>
          </tbody>
        </Table>
        <P style={{ marginTop: "2.0rem" }}>
          <ul>
            <li>
            遊戲中有三種跑道，分別是：石子路、芳草地、烈日沙灘。 石子路需要有鞋子才能跑，芳草地需要有褲子才能跑，烈日沙灘需要有上衣才能跑。
            </li>
            <li>
            用戶可以選擇要跑的跑道，所有裝備的收益按照其選擇的跑道來計算。 提前一天選擇，如果跑道與裝配不匹配，則其收益會减少10%。
            </li>
            <li>
            一個n級屬性卡，其載量為n，當跑道超載時用戶的收益會下降，當跑道每天超過載量10000時，每超過1000則收益下降1%，最多下降40%。 内容卡舒適性值的收益不受影響。
            </li>
          </ul>
        </P>
        {/* <T>Runbit DAO 属性卡IDO</T>
        <P style={{ textAlign: "left", marginTop: "1.5rem", color: "#4A4A4A" }}>
          IDO认购的产品为游戏属性卡，限量发行1000张，发行价值500RT，每个地址限购一张，每张卡都由算法自动生成，具有唯一性。初始认购价格为180USDT，认购价格每天上涨10USDT，认购时间持续25天，到期截止。
        </P>
        <ST style={{ textAlign: "left" }}>属性卡IDO期间社区建设奖励：</ST>
        <div
          style={{
            marginBottom: "2.1rem",
            marginTop: "3.0rem",
            overflow: "auto",
          }}
        >
          <img style={{ width: "54.2rem" }} src="/image/help6.png" alt="" />
        </div>
        <P>
          <ul>
            <li>
              各级社区长认购的所有RT都将添加到资金池作为项目 的初始资金池。
            </li>
            <li>
              注团队有效地址是指认购完成地址。推荐者须自身认
              购后才能获得所有奖励。
            </li>
          </ul>
        </P> */}
        <T>
          Runbit DAO
          <br />
          游戏中社区建设奖励
        </T>
        <div
          style={{
            marginBottom: "2.1rem",
            marginTop: "3.0rem",
            overflow: "auto",
          }}
        >
          <img style={{ width: "73.0rem" }} src="/image/help5.png" alt="" />
        </div>
        <P>
          <ul>
            <li>
              屬性卡每消耗100耐久（1天）可產生1活躍度，每個用戶每天最多可產生1活躍度
            </li>
            <li>
              升級後不重複拿分紅；
              升級後考核，每週團隊活躍度增長不低於4%增長，如果第一周不達標則拿70%分紅獎勵，第二周不達標拿50%分紅獎勵，第三周不達標拿40%分紅獎勵。
              第四周不達標比例將不再下降。
              以後只要有一周達標，就可以再正常分紅。
            </li>
            <li>推薦者須自身先購買屬性卡後才能獲得所有獎勵。</li>
          </ul>
        </P>
      </Container>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background-image: linear-gradient(#fdf8c4 1%, #f9f9f9 9%);
`;
const Container = styled.div`
  padding: 0 2.0rem 3.6rem;

  * {
    font-size: 1.4rem;
    font-weight: 400;
    line-height: 2.0rem;
    color: #969696;
    line-height: 2.0rem;
  }
`;
const T = styled.div`
  font-weight: 600;
  font-size: 2.6rem;
  line-height: 1.3;
  letter-spacing: 0.05em;
  color: #000000;
  text-align: center;
  margin-top: 5.8rem;
`;

const ST = styled.div`
  letter-spacing: 0.2em;
  color: #4a4a4a;
  text-align: center;
  margin: 1.5rem 0 1.6rem;
`;

const P = styled.div`
  span {
    color: #000000;
  }
  ul {
    padding-left: 1.0rem;
    li {
      list-style: disc;
    }
  }
`;

const Table = styled.table`
  width: 100%;
  background: linear-gradient(180deg, #f1f1f1 0%, rgba(255, 255, 255, 0) 100%);
  border-radius: .8rem;
  text-align: center;
  border-collapse: collapse;

  td {
    padding: 1.4rem 0;
    font-size: 1.3rem;
    border-bottom: 1px solid #bdbdbd;
    color: #000;
  }
  tr:last-child td {
    border-bottom: none;
  }
`;
